export function currentPath() {
  return window.location.pathname + window.location.search;
}
